import { render, staticRenderFns } from "./StatusAccountDelete.vue?vue&type=template&id=00364b62&scoped=true&"
import script from "./StatusAccountDelete.vue?vue&type=script&lang=js&"
export * from "./StatusAccountDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00364b62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00364b62')) {
      api.createRecord('00364b62', component.options)
    } else {
      api.reload('00364b62', component.options)
    }
    module.hot.accept("./StatusAccountDelete.vue?vue&type=template&id=00364b62&scoped=true&", function () {
      api.rerender('00364b62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Customers/StatusAccountDelete.vue"
export default component.exports